import React, { useState, useEffect } from 'react';
import '../styles/myRequests.css';

export const Pagination = ({ currentPage, totalPages, totalCount, itemsPerPage, onPageChange }) => {

    const [inputPage, setInputPage] = useState(currentPage);

    useEffect(() => {
        setInputPage(currentPage);
    }, [currentPage]);

    const commitPage = () => {
        const val = parseInt(inputPage);
        if (!isNaN(val) && val >= 1 && val <= totalPages) {
            onPageChange(val);
        } else {
            setInputPage(currentPage); // revert to last valid if out of range
        }
    };

    return (
        <div className="pagination">
            <span className="pagination-summary">
                Showing {((currentPage - 1) * itemsPerPage) + 1}–{Math.min(currentPage * itemsPerPage, totalCount)} of {totalCount.toLocaleString()} records
            </span>

            <div className="pagination-controls">
                <button onClick={() => onPageChange(1)} disabled={currentPage === 1} title="First page">«</button>

                <button onClick={() => onPageChange(Math.max(currentPage - 1, 1))} disabled={currentPage === 1} title="Previous page">
                    ‹ Previous
                </button>

                <span className="pagination-input-group">
                    Page
                    <input
                        type="number"
                        min={1}
                        max={totalPages}
                        value={inputPage}
                        onChange={(e) => setInputPage(e.target.value)}
                        onBlur={commitPage}
                        onKeyDown={(e) => e.key === 'Enter' && commitPage()}
                        className="pagination-page-input"
                    />
                    of {totalPages.toLocaleString()}
                </span>

                <button onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))} disabled={currentPage === totalPages} title="Next page">
                    Next ›
                </button>

                <button onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages} title="Last page">»</button>
            </div>
        </div>
    );
};